import { MemberType } from '@wwf/sdk';
import { MemberTypeLabel } from '@domain/labels';

export const findMemberTypeLabel = (
    memberTypeList: MemberTypeLabel[],
    memberValue: MemberType
) => {
    return memberTypeList.find(memberType => memberType.value === memberValue)
        ?.label;
};
